import React, { useEffect, useState, useRef } from "react";
import DynamicTable from "../DynamicTable";
import ImageGallery from "../../Components/ImageGallery/ImageGallery";

const SectionOne = (props) => {
    const {handleButtonClick, setSelectedOptions, selectedOptions, toggleOption, data ,addMessages ,showMaximumChat } = props;

    const [onClickYes, setOnClickYes] = useState(false);
    const [onClickNo, setOnClickNo] = useState(false);

    const isYesStepValid = (data?.step_1_yes_next_steps || '' ).toLowerCase() !== 'no';
    const isNoStepValid = (data?.step_1_no_next_steps || '').toLowerCase() !== 'no';


    // const  onClickButton = (isYesStepValid,isNoStepValid ,value) =>{
    
    //     if(!isYesStepValid && value === 'Yes' && data?.step_1_yes_call_logs){
            
    //         addMessages(data?.step_1_yes_call_logs)
    //     }

    //     if(!isNoStepValid && value === 'No' && data?.step_1_no_call_logs){

    //         addMessages(data?.step_1_no_call_logs)
    //     }

    // }
    // useEffect(()=>{
    //     if (onClickNo && data?.step_1_no_text?.toLowerCase() === "nan") {
    //         props?.addMessages("Work Order", 10);
    //     }
    // }, [onClickNo, onClickYes])

    // useEffect(()=>{

    //     if(onClickYes && data?.step_1_yes_call_logs){
    //         localStorage.setItem(
    //             "troubleShooting",
    //             JSON.stringify({ key1: data?.step_1_yes_call_logs })
    //           );
    //     }

    //     if(isNoStepValid && data?.step_1_no_call_logs ){
    //         localStorage.setItem(
    //             "troubleShooting",
    //             JSON.stringify({ key1: data?.step_1_no_call_logs })
    //           );
    //     }
    // })

    return (
        <>
            <div style={{ paddingTop: "0px" ,fontSize : showMaximumChat && '16px'}} className="error-message-head1"  >
                {data?.step_1_title}
            </div>
            <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_1_desc}}>
            </div>

            <div style={{ gap: "8px", display: "flex", marginTop: "22px" }}>
                <button
                    onClick={() => {
                        localStorage.setItem(
                            "troubleShooting",
                            JSON.stringify({ key1: data?.step_1_yes_call_logs })
                          );
                        handleButtonClick(1, "yes" ,{section : 'one',value:isYesStepValid});
                        // setSelectedOptions([true, true, false, false, false, false, false]);
                        setOnClickYes(true);
                        setOnClickNo(false);
                          // Update selectedOptions based on `step_1_yes_text`
                        if (isYesStepValid) {
                            setSelectedOptions([true, true, false, false, false, false, false]);
                        } else{
                            setSelectedOptions([true, false, false, false, false, false, false]);
                        }
                        // onClickButton(isYesStepValid ,isNoStepValid,'Yes')
                    }}
                    className={`option-button ${toggleOption[1] === "yes" ? "clicked" : ""}`}
                 >
                    Yes
                </button>
                <button
                    onClick={() => {
                        localStorage.setItem(
                            "troubleShooting",
                            JSON.stringify({ key1: data?.step_1_no_call_logs })
                          );
                        handleButtonClick(1, "no",{section : 'one',value:isNoStepValid});
                        setOnClickYes(false);
                        setOnClickNo(true);
                        if (isNoStepValid) {
                            setSelectedOptions([true, true, false, false, false, false, false]);
                        } else{
                            setSelectedOptions([true, false, false, false, false, false, false]);
                        }
                        // onClickButton(isYesStepValid ,isNoStepValid,'No')
                    }}
                    className={`option-button ${toggleOption[1] === "no" ? "clicked" : ""}`}
                >
                    No
                </button>
            </div>

            {/* Show Yes Text or No Text based on selection */}
            {onClickYes && data?.step_1_yes_images && <ImageGallery data={data?.step_1_yes_images} showMaximumChat={showMaximumChat}  setIsShowMaximumChat={props?.setIsShowMaximumChat}/>}
            {onClickYes && <div className="error-message-head2"  style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_1_yes_text}}></div>}
            {onClickNo && data?.step_1_no_text?.toLowerCase() !== "nan" && <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_1_no_text}}></div>}

            {onClickYes && data?.step_1_yes_call_logs && <DynamicTable data={data?.step_1_no_call_logs} /> }
            {onClickNo && data?.step_1_no_call_logs && <DynamicTable data={data?.step_1_no_call_logs} /> }
        </>
    );
};
export default SectionOne